import ClassModel from "src/models/ClassModel";
import {
  CapacityStatus,
  GroupRegistrationStatus,
  MembershipStatus,
} from "types/code-generator";

export function getOfferingCapacity(data: {
  id: string;
  capacity: CapacityStatus;
  maintainWaitlist: boolean;
  maxEnrollment: number;
  waitlistCapacity: number;
  registrations?: {
    status: GroupRegistrationStatus;
  }[];
  memberships?: {
    status: MembershipStatus;
  }[];
}) {
  // console.log("data", data);
  let roster = [];
  let waitlist = [];

  if ("registrations" in data) {
    const model = new ClassModel(data);
    roster = model.getRoster();
    waitlist = model.getWaitlist();
  }

  if ("memberships" in data) {
    roster = data.memberships.filter(
      (m) => m.status === MembershipStatus.Active
    );
    waitlist = data.memberships.filter(
      (m) => m.status === MembershipStatus.Waitlist
    );
  }

  const isAvailable =
    Math.max(0, data.maxEnrollment - roster.length) ||
    data.maxEnrollment === null;
  const isWaitlist =
    data.maxEnrollment !== null &&
    data.maintainWaitlist &&
    (data.waitlistCapacity === null ||
      waitlist.length < data.waitlistCapacity) &&
    (waitlist.length > 0 || roster.length >= data.maxEnrollment);
  const isWaitlistAvailable =
    data.maxEnrollment !== null &&
    data.maintainWaitlist &&
    data.maxEnrollment - roster.length > 0 &&
    waitlist.length > 0;
  const isFull =
    data.maxEnrollment !== null &&
    roster.length >= data.maxEnrollment &&
    (!data.maintainWaitlist || waitlist.length >= data.waitlistCapacity);

  if (data.id === "cm2xnxnpu00gzgakpuotlh2ub") {
    console.log("roster", roster.length);
    console.log("waitlist.length", waitlist.length);
    // console.log("c", c);
    console.log("isAvailable", isAvailable);
    console.log("isWaitlist", isWaitlist);
    console.log("isWaitlistAvailable", isWaitlistAvailable);
    console.log("isFull", isFull);
  }

  let capacity = data.capacity;

  if (isWaitlistAvailable && isAvailable) {
    if (data.capacity !== CapacityStatus.WaitlistAvailable) {
      capacity = CapacityStatus.WaitlistAvailable;
    }
  } else if (isAvailable) {
    if (data.capacity !== CapacityStatus.Available) {
      capacity = CapacityStatus.Available;
    }
  } else if (isWaitlistAvailable) {
    if (data.capacity !== CapacityStatus.WaitlistAvailable) {
      capacity = CapacityStatus.WaitlistAvailable;
    }
  } else if (isWaitlist) {
    if (data.capacity !== CapacityStatus.Waitlist) {
      capacity = CapacityStatus.Waitlist;
    }
  } else if (isFull) {
    if (data.capacity !== CapacityStatus.Full) {
      capacity = CapacityStatus.Full;
    }
  }

  return capacity;
}
